/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as LoginRouteImport } from './routes/login'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ItemsItemIdRouteImport } from './routes/items/$itemId'
import { Route as EmailsEmailIdRouteImport } from './routes/emails/$emailId'

const SignupRoute = SignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const ItemsItemIdRoute = ItemsItemIdRouteImport.update({
  id: '/items/$itemId',
  path: '/items/$itemId',
  getParentRoute: () => rootRouteImport,
} as any)
const EmailsEmailIdRoute = EmailsEmailIdRouteImport.update({
  id: '/emails/$emailId',
  path: '/emails/$emailId',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/signup': typeof SignupRoute
  '/emails/$emailId': typeof EmailsEmailIdRoute
  '/items/$itemId': typeof ItemsItemIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/signup': typeof SignupRoute
  '/emails/$emailId': typeof EmailsEmailIdRoute
  '/items/$itemId': typeof ItemsItemIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/signup': typeof SignupRoute
  '/emails/$emailId': typeof EmailsEmailIdRoute
  '/items/$itemId': typeof ItemsItemIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths: '/' | '/login' | '/signup' | '/emails/$emailId' | '/items/$itemId'
  fileRoutesByTo: FileRoutesByTo
  to: '/' | '/login' | '/signup' | '/emails/$emailId' | '/items/$itemId'
  id:
    | '__root__'
    | '/'
    | '/login'
    | '/signup'
    | '/emails/$emailId'
    | '/items/$itemId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  LoginRoute: typeof LoginRoute
  SignupRoute: typeof SignupRoute
  EmailsEmailIdRoute: typeof EmailsEmailIdRoute
  ItemsItemIdRoute: typeof ItemsItemIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/signup': {
      id: '/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof SignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/items/$itemId': {
      id: '/items/$itemId'
      path: '/items/$itemId'
      fullPath: '/items/$itemId'
      preLoaderRoute: typeof ItemsItemIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/emails/$emailId': {
      id: '/emails/$emailId'
      path: '/emails/$emailId'
      fullPath: '/emails/$emailId'
      preLoaderRoute: typeof EmailsEmailIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  LoginRoute: LoginRoute,
  SignupRoute: SignupRoute,
  EmailsEmailIdRoute: EmailsEmailIdRoute,
  ItemsItemIdRoute: ItemsItemIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
